<template>
  <v-container v-if="apiLoaded">
    <h1>
      <span>Проводки</span>
      <div>
        <WiringDialog :resetKey="resetKey" @wiringSaved="reloadRegisterTab" title="Создать проводку"  >
          <template v-slot="{ disabled, attrs, on, click }">
            <v-btn
              :disabled="disabled"
              :bind="attrs"
              :on="on" 
              @click=click>
              Создать проводку</v-btn>
          </template>
        </WiringDialog>
      </div>
    </h1>
    <WRegisterTab :key="resetKey" :config="config" :selectMode="false" :storageKey="'wiringListHeadersRegister'"/>
  </v-container>
</template>

<script>
import { wiringsRegisterConfig} from './RegisterConfigs';
import WRegisterTab from './WRegisterTab.vue';
import WiringDialog from '../wirings/WiringDialog.vue';

export default {
  name: 'WiringsRegister',
  props: {},
  components: { WRegisterTab, WiringDialog },
  data() {
    return {
      config: wiringsRegisterConfig,
      resetKey: Math.random()
    };
  },
  methods: {
    reloadRegisterTab() {
      this.resetKey = Math.random();
    }
  },
  watch: {
  },
  async beforeMount() {
    this.apiLoaded = true;
  },
};
</script>
